import { StringHelper } from "../../../../../../helper";
import styles from "./FormText.module.scss";

interface Props {
  value?: string;
}

export const FormText = ({ value }: Props) => {
  const text = StringHelper.verticalBarSplit(value)[1];
  return <div className={styles.text}>{text}</div>;
};
